import axios from 'axios';
import { WriterProfileData, WriterProfileResponse } from './types';

export const getWriterProfile = async (): Promise<WriterProfileResponse | null> => {
  const res = await axios.get('/users/writer-profile');
  return res.data ?? null;
};

/** Partial update. Empty strings clear a field (the API accepts '' for goal/experienceLevel). */
export const saveWriterProfile = async (
  data: Partial<WriterProfileData>,
): Promise<WriterProfileResponse> => {
  const res = await axios.put('/users/writer-profile', data);
  return res.data;
};

export const completeWriterProfile = async (
  data: Partial<WriterProfileData>,
): Promise<WriterProfileResponse> => {
  const res = await axios.post('/users/writer-profile/complete', data);
  return res.data;
};
